<template>
  <section>
    <GroupTitle />
    <Feature :title="$t('CONSIGNMENT_STOCK_QUERY')" :iconClass="'fa-database'">
      <FormRow
        :fieldNameArr="['*' + $t('PLANT_CODE'), $t('DELTA_PN'), $t('BEGIN_DATE'), '~', '*' + $t('PERIOD_TYPE'), '*' + $t('REPORT_TYPE')]">
        <Select filterable v-model="plantCode" style="width: 200px" slot="a">
          <Option v-for="(item, index) in plantList" :value="item" :key="index">{{ item }}</Option>
        </Select>
        <Input v-model="deltaPn" search :enter-button="$t('MORE')" @on-search="moreDeltaPn" slot="b" />
        <DatePicker v-model="validFrom" type="date" format="yyyy-MM-dd" :placeholder="$t('CHOOSE') + $t('VALID_FROM')"
          slot="c"></DatePicker>
        <DatePicker v-model="validTo" type="date" format="yyyy-MM-dd" :placeholder="$t('CHOOSE') + $t('VALID_TO')"
          slot="d"></DatePicker>
        <Select filterable v-model="periodTypeValue" style="width: 200px" slot="e" @on-change="changePeriod($event)">
          <Option v-for="(item, index) in periodTypeList" :value="item.value" :key="index">{{ item.label }}</Option>
        </Select>
        <Select filterable v-model="reportTypeValue" style="width: 200px" slot="f">
          <Option v-for="(item, index) in reportTypeList" :value="item.value" :key="index">{{ item.label }}</Option>
        </Select>
      </FormRow>
      <ButtonRow>
        <Button type="primary" slot="0" @click="search">{{ $t('QUERY') }}</Button>
        <Button type="primary" slot="1" @click="download">{{ $t('DOWNLOAD_EXCEL') }}</Button>
        <Button type="primary" slot="2" @click="clear">{{ $t('CLEAR') }}</Button>
      </ButtonRow>

      <TablePage :pageObj="pageObj" @changePage="changePage" :tableWidth="windowWidth" :columnsList="detailColumnsList"
        :resultList="dataList" v-if="isData">
      </TablePage>
    </Feature>

    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="deltaPnModel"
      :title="$t('DELTA_PN_MORE')" @on-ok="confirmDeltaPnModel">
      <Input v-model="deltaPnValue" type="textarea" :rows="10" />
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="deltaPnTableModel"
      :title="$t('CONSIGNMENT_STOCK_INFORMATION')" :ok-text="$t('CLOSE')" cancel-text="" class="deltaPnTableModel">
      <h6 class="model-title">{{ groupCodeDesc }}</h6>
      <FormRow
        :fieldNameArr="[$t('PART_NO') + ':', $t('PART_DESCRIPTION') + ':', $t('VENDOR_PN') + ':', $t('IQC_STOCK') + ':', $t('UNIT') + ':', $t('STOCK_QUANTITY') + ':']">
        <span slot="a">{{ modelDeltaPn }}</span>
        <span slot="b">{{ modelPartDescription }}</span>
        <span slot="c">{{ modelVnCode }}</span>
        <span slot="d">{{ modelStockIqc }}</span>
        <span slot="e">{{ modelStockUnit }}</span>
        <span slot="f">{{ modelStockQty }}</span>
      </FormRow>
    </Modal>
  </section>

</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo } from "@/util/alert"
import { Translate, DateToString, DownloadFile, ExceptionHandling } from "@/util/common"
import GroupTitle from "@/views/default/GroupTitle"

export default {
  name: "ConsignmentStockQuery",
  components: {
    GroupTitle
  },
  created() {
    // 原本這寫法不可能拿到 getGroupCode 的 因為在 created 的時候還沒有 getGroupCode 就想判斷有沒有是不行的
    // 就先註解掉下面的啦
    // let vueInstance = this
    // if (vueInstance.getGroupCode()) {
    //   vueInstance.toggleLoading(true)
    //   vueInstance.$getPlantCode(vueInstance, vueInstance.getGroupCode().ecUuid).then(data => {
    //     vueInstance.toggleLoading(false)
    //     if (data) {
    //       data.forEach((plant) => {
    //         this.plantList.push(plant.objectKey)
    //       })
    //     } else {
    //       vueInstance.toggleLoading(false)
    //       AlertInfo(vueInstance, vueInstance.$t('COMMON_MESSAGE_NOT_AUTH')).then(() => {
    //       })
    //       vueInstance.$router.push("/home")
    //     }
    //   })
    // } else {
    //   vueInstance.$router.push("/home")
    // }
  },
  watch: {
    getGroupCode: {
      immediate: true,
      handler(group) {
        if (!group) return
        this.fetchPlant(group.ecUuid)
      }
    }
  },
  data() {
    return {
      deltaPnModel: false,
      deltaPnTableModel: false,
      modelDeltaPn: "",
      modelPartDescription: "",
      modelVnCode: "",
      modelStockIqc: "",
      modelStockUnit: "",
      modelStockQty: "",
      plantList: [],
      plantCode: '',
      dataList: [],
      deltaPnValue: '',
      validFrom: null,
      validTo: null,
      periodTypeValue: 'W',
      periodTypeList: [
        {
          value: 'W',
          label: 'Weekly'
        },
        {
          value: 'M',
          label: 'Monthly'
        }
      ],
      reportTypeValue: 'SUMMARY',
      reportTypeList: [
        {
          value: 'SUMMARY',
          label: 'Summary'
        },
        {
          value: 'DETAIL',
          label: 'Detail'
        }
      ],
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      detailColumnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("OA_CODE");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'oaCode',
          width: 80,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("DELTA_PN");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            return h("a", {
              attrs: { style: "color:#46A3FF" },
              on: {
                click: () => {
                  const vueInstance = this
                  vueInstance.toggleLoading(true)
                  vueInstance.$consignmentHttp
                    .get("/consign-stock/" + vueInstance.plantCode + "/" + params.row.deltaPn + "/" + params.row.vnCode, JSON.stringify())
                    .then((response) => {
                      vueInstance.modelDeltaPn = response.data.deltaPn
                      vueInstance.modelPartDescription = response.data.partDescription
                      vueInstance.modelVnCode = response.data.vnCode
                      vueInstance.modelStockIqc = response.data.stockIqc
                      vueInstance.modelStockUnit = response.data.stockUnit
                      vueInstance.modelStockQty = response.data.stockQty
                      vueInstance.deltaPnTableModel = true
                    })
                    .catch((error) => {
                      let text = ExceptionHandling(error.response)
                      vueInstance.$Swal.fire({
                        icon: "error",
                        title: Translate("COMMON_MESSAGE_ERROR"),
                        html: text,
                      })
                    })
                    .finally(() => {
                      vueInstance.toggleLoading(false)
                    })
                },
              },
            }, params.row.deltaPn)
          },
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PART_DESCRIPTION");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'partDescription',
          width: 180,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("VENDOR_PN");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'vnPart',
          width: 150,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("VENDOR_CODE") + ' / ' + this.$t("OA_VENDOR_NAME");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'vendorCodeVendorName',
          width: 200,
          sortable: true,
          render: (h, params) => {
            let vnCode = params.row.vnCode ? params.row.vnCode : ""
            let vnName = params.row.vnName ? params.row.vnName : ""
            let text = vnCode + "<br>" + vnName
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PI_CODE") + '<br>' + this.$t("PI_NAME");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 200,
          sortable: true,
          render: (h, params) => {
            let piCode = params.row.piCode ? params.row.piCode : ""
            let piName = params.row.piName ? params.row.piName : ""
            let text = piCode + "<br>" + piName
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PERIOD_TYPE");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'periodType',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("BEGIN_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'beginQty',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("RECEIVE_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'receiveQty',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("RETURN_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'returnQty',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("ISSUE_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'issueQty',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("BALANCE_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'balanceQty',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("STOCK_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'stockQty',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("IQC_STOCK");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'stockIqc',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("BLOCKED_STOCK_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'blockStock',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("BEGIN_PERIOD");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 150,
          sortable: true,
          render: (h, params) => {
            let beginDate = params.row.beginDate ? params.row.beginDate : ""
            let endDate = params.row.endDate ? params.row.endDate : ""
            let text = beginDate + " ~ " + endDate
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: "center",
        }
      ],
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth", "getConsignmentStockDeltaPn", "getGroupCode"]),
    ...mapActions(["toggleLoading", "setConsignmentStockDeltaPn"]),
    moreDeltaPn() {
      this.deltaPnModel = true
      this.setConsignmentStockDeltaPn("")
    },
    confirmDeltaPnModel() {
      this.deltaPnValue.split('\n').forEach(a => {
        this.setConsignmentStockDeltaPn(this.getConsignmentStockDeltaPn().concat(a.trim() + ";"))
      })
      this.setConsignmentStockDeltaPn(this.getConsignmentStockDeltaPn().substr(0, this.getConsignmentStockDeltaPn().length - 1))
    },
    fetchPlant(ecUuid) {
      this.toggleLoading(true)
      this.$getPlantCode(this, ecUuid).then(data => {
        this.toggleLoading(false)
        if (data) {
          this.plantList = data.map(item => item.objectKey)
        } else {
          AlertInfo(this, this.$t('COMMON_MESSAGE_NOT_AUTH'))
        }
      })
    },
    search(init) {
      const vueInstance = this
      let errorMessage = vueInstance.valid(vueInstance.plantCode, vueInstance.periodTypeValue, vueInstance.reportTypeValue)
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        console.log(init)
        if (init) {
          vueInstance.pageObj = {
            "page": 0,
            "totalPage": 0,
            "totalCount": 0,
            "pageSize": 20
          }
        }
        this.setPeriodDate(this)
        vueInstance.dataList = []
        vueInstance.toggleLoading(true)
        vueInstance.$consignmentHttp
          .post("/consign-stock/query?page=" + vueInstance.pageObj.page + '&size=' + vueInstance.pageObj.pageSize, JSON.stringify(buildCateria(vueInstance)))
          .then((response) => {
            this.toggleLoading(false)
            if (response.data._embedded) {
              let data = response.data
              this.dataList = data._embedded.stockQuerySummaryAndDetailResourceList
              vueInstance.pageObj = {
                "page": data.page.number + 1,
                "totalPage": data.page.totalPages,
                "totalCount": data.page.totalElements,
                "pageSize": data.page.size
              }
            } else {
              vueInstance.$Notice.success({
                title: Translate("COMMON_MESSAGE_INFO"),
                desc: Translate("COMMON_MESSAGE_INFO"),
                render: h => {
                  return h('span', [
                    Translate("COMMON_TEXT_NOTHING")
                  ])
                }
              });
            }
          })
          .catch(() => { })
      }
    },
    download() {
      let vueInstance = this
      let errorMessage = vueInstance.valid(vueInstance.plantCode, vueInstance.periodTypeValue, vueInstance.reportTypeValue)

      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        vueInstance.toggleLoading(true)
        vueInstance.$consignmentHttp
          .post("consign-stock/download", JSON.stringify(buildCateria(vueInstance)), { responseType: 'blob' })
          .then((response) => {
            DownloadFile(new Blob([response.data]), response.headers['content-disposition'].split('\"')[1])
          })
          .catch((error) => {
            let text = ExceptionHandling(error.response)
            vueInstance.$Swal.fire({
              icon: "error",
              title: Translate("COMMON_MESSAGE_ERROR"),
              html: text,
            })
            vueInstance.$router.push("/home")
          })
          .finally(() => {
            vueInstance.toggleLoading(false)
          })
      }
    },
    valid(plantCode, periodTypeValue, reportTypeValue) {
      let errorMessage = ""
      if (!plantCode) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('PLANT_CODE') + " <br>"
      }
      if (!periodTypeValue) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('PERIOD_TYPE') + " <br>"
      }
      if (!reportTypeValue) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('REPORT_TYPE') + " <br>"
      }
      return errorMessage
    },
    clear() {
      this.plantCode = ''
      this.deltaPn = ''
      this.deltaPnValue = ''
      this.validFrom = null
      this.validTo = null
      this.periodTypeValue = ''
      this.reportTypeValue = ''
    },
    changePeriod(value) {
      this.periodTypeValue = value
      this.setPeriodDate(this)
    },
    changePage(page) {
      this.pageObj.page = page - 1
      this.search(false)
    },
    setPeriodDate(vueInstance) {
      if (vueInstance.validFrom) {
        let temp = DateToString(vueInstance.validFrom, "-") + " ~ "
        if (vueInstance.periodTypeValue == 'MONTHLY') {
          vueInstance.periodDateStr = temp + DateToString(AddMonths(vueInstance.validFrom, 1), "-")
        } else if (vueInstance.periodTypeValue == 'WEEKLY') {
          vueInstance.periodDateStr = temp + DateToString(AddWeeks(vueInstance.validFrom, 1), "-")
        } else {
          vueInstance.periodDateStr = ""
        }
      }
    }
  },
  computed: {
    getGroupCode() {
      return this.$store.getters.getGroupCode
    },
    groupCodeDesc() {
      const group = this.getGroupCode  
      return group ? group.code + " " + group.name : ""
    },
    modalSize() {
      return this.getModalSize()
    },
    isData() {
      return this.dataList && this.dataList.length > 0
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    },
    deltaPn: {
      get() {
        return this.getConsignmentStockDeltaPn()
      },
      set(value) {
        this.dataList = []
        return this.setConsignmentStockDeltaPn(value)
      }
    },
  }
}

function buildCateria(vueInstance) {
  let deltaPnArray = []
  vueInstance.getConsignmentStockDeltaPn().split(';').forEach(a => {
    deltaPnArray.push(a)
  })
  return {
    plant: vueInstance.plantCode,
    deltaPartList: vueInstance.getConsignmentStockDeltaPn() == "" ? [] : deltaPnArray,
    periodType: vueInstance.periodTypeValue,
    consignStokReportTypeEnum: vueInstance.reportTypeValue,
    beginDateFrom: vueInstance.validFrom != "" && vueInstance.validFrom != null ? DateToString(vueInstance.validFrom, "-") : null,
    beginDateTo: vueInstance.validTo != "" && vueInstance.validTo != null ? DateToString(vueInstance.validTo, "-") : null
  }
}
</script>

<style scoped>
.model-title {
  text-align: center;
  margin-bottom: 16px;
}

.deltaPnTableModel .flex-container {
  display: block;
}
</style>
